import { css } from '@emotion/react';
import type { NvTableCellProps } from 'shared/components/nv-table';
import Audience from '../audience';

const AudienceCell = ({
  className,
  cell,
}: NvTableCellProps<any>) => {
  const styles = css`
    // TODO: This seems like I shouldn't need to do this (i.e. it should be a universal class)
    .gap-2 {
      gap: 1rem;
    }
  `;

  const target = cell.getValue();

  return (
    <div css={styles} className={`d-flex align-items-center ${className}`}>
      <Audience target={target} className='pb-1' />
    </div>
  );
};

export default AudienceCell;
